
import React from 'react';

const LoadControlInfo: React.FC = () => {
  return (
    <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4 border border-blue-100 dark:border-blue-800">
      <h3 className="text-sm font-medium text-blue-800 dark:text-blue-300 mb-2">Load Control Information</h3>
      <p className="text-sm text-blue-700 dark:text-blue-400">
        This panel allows you to control and schedule various loads in your facility. 
        Toggle switches to turn loads on or off, set schedules for automatic operation,
        and implement efficiency recommendations to optimize energy consumption.
      </p>
    </div>
  );
};

export default LoadControlInfo;
